/**
 * Tiny logger utility — only emits in development.
 * In production builds (NODE_ENV === 'production'), calls become no-ops.
 * Swap for Sentry/LogRocket etc. when ready.
 */
const isDev = process.env.NODE_ENV !== 'production';

const noop = () => {};

const logger = {
  log: isDev ? (...args) => console.log(...args) : noop,
  info: isDev ? (...args) => console.info(...args) : noop,
  warn: isDev ? (...args) => console.warn(...args) : noop,
  error: isDev ? (...args) => console.error(...args) : noop,
};

export default logger;
